import { Theme, styled, Typography } from '@yuno/design-system-web'
import error from '../assets/error.svg'
import { useTranslation } from 'react-i18next'

const Wrapper = styled('div')<{ transparent?: boolean; theme?: Theme }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  flex-direction: column;
  width: 100%;
  background: ${({ transparent, theme }) =>
    !transparent ? theme.palette.grey[0] : 'transparent'};
  padding: 16px;
`

const Title = styled(Typography)<{ theme?: Theme }>`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.xl.bold.fontWeight};
  font-size: ${({ theme }) => theme.typography.base.bold.fontSize};
`

const Description = styled(Typography)<{ theme?: Theme }>`
  width: 328px;
  text-align: center;
  color: ${({ theme }) => theme.palette.grey[5]};
  font-weight: ${({ theme }) => theme.typography.small.regular.fontWeight};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
`

const ErrorConnection = ({ title, description }) => {
  const { t } = useTranslation()
  return (
    <Wrapper transparent>
      <img src={error} alt="error" width={132} height={114} />
      <Title>{t(title)}</Title>
      <Description>{t(description)}</Description>
    </Wrapper>
  )
}

export default ErrorConnection
